import React, { useEffect, useState } from 'react';
import { AssistantMessage } from '../../contexts/SearchResultsContext';

interface FloatingMessageBubbleProps {
  message: AssistantMessage;
  onDismiss: (id: string) => void;
}

const FloatingMessageBubble: React.FC<FloatingMessageBubbleProps> = ({ message, onDismiss }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    if (!isHovered) {
      const timer = setTimeout(() => {
        setIsVisible(false);
        // Wait for fade out animation to complete before removing
        setTimeout(() => {
          onDismiss(message.id);
        }, 300);
      }, 5000); // Show for 5 seconds

      return () => clearTimeout(timer);
    }
  }, [isHovered, message.id, onDismiss]);

  return (
    <div
      className={`transform transition-all duration-300 ease-in-out ${
        isVisible ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0'
      }`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="bg-[var(--rhea-bg-secondary)] border border-[var(--rhea-card-border)] rounded-lg p-3 shadow-lg max-w-md">
        <p className="text-sm text-[var(--rhea-text-primary)]">{message.content}</p>
      </div>
    </div>
  );
};

export default FloatingMessageBubble; 